module.exports = __webpack_public_path__ + "img/qa.b67f7979.svg";